import { TableComponent as Table } from '../../components'
import { ReactComponent as iconEdit } from '../../assets/img/edit.svg'
import { ReactComponent as iconEye } from '../../assets/img/eye.svg'
import { ButtonComponent as Button } from '../../components'
import { Space } from 'antd'

const ProductsTable = (props) => {
    const { products, loading, onEdit, onManageFiles } = props
    
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '10%',
            sorter: {
                compare: (a, b) => a.id - b.id,
                multiple: 1,
            },
        },
        {
            title: 'Nome',
            dataIndex: 'nome',
            key: 'nome',
            align: 'center',
            width: '25%',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: '15%',
            render: (value) => {
                const statusMap = {
                    'active': 'Ativo',
                    'inactive': 'Inativo',
                    'draft': 'Rascunho'
                }
                return statusMap[value] || value
            }
        },
        {
            title: 'Tipo',
            dataIndex: 'tipo',
            key: 'tipo',
            align: 'center',
            width: '15%',
        },
        {
            title: 'Issuer',
            dataIndex: 'issuer',
            key: 'issuer',
            align: 'center',
            width: '15%',
        },
        {
            title: 'Ações',
            key: 'actions',
            align: 'center',
            width: '20%',
            render: (_, record) => (
                <Space size="small">
                    <Button 
                        type="primary" 
                        icon={iconEdit} 
                        onClick={(e) => {
                            e.stopPropagation()
                            onEdit(record.id)
                        }}
                    >
                        Editar
                    </Button>
                    <Button 
                        type="primary" 
                        icon={iconEye}
                        onClick={(e) => {
                            e.stopPropagation()
                            onManageFiles(record.id)
                        }}
                    >
                        Arquivos
                    </Button>
                </Space>
            ),
        }
    ]
    
    return (
        <Table 
            loading={loading}
            column={columns} 
            data={products} 
            layout="fixed"
            id="products"
        />
    )
}

export default ProductsTable
